/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.frontend.app.usersettings.rpc.UserSettingsRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

/**
 *  This class can be used as a response type in cases where no response is needed or
 *  where <code>void</code> might have been used in a REST-ful context.
 */

/**
 *  @deprecated UserSettingsRpcImpl never actually returns an Optional.empty() for {@link #getTheme()},
 *              so we're swapping to using {@link UserThemeSettingsResponseIF} instead which just
 *              returns the theme as a `WireSafeEnum<ThemeName>` instead.
 *             This interface will be deleted once all users are no longer using it.
 */

export const getUserSettingsRpc = {
  serviceName: 'com.hubspot.frontend.app.usersettings.rpc.UserSettingsRpc',
  rpcName: 'getUserSettings',
  auth: 'app',
  fingerprint: 'yWIid3C4IsgjZE7L4o0vkZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getUserThemeSettingsRpc = {
  serviceName: 'com.hubspot.frontend.app.usersettings.rpc.UserSettingsRpc',
  rpcName: 'getUserThemeSettings',
  auth: 'app',
  fingerprint: 'yWIid3C4Isg2tmaANxd15pwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateUserThemeSettingRpc = {
  serviceName: 'com.hubspot.frontend.app.usersettings.rpc.UserSettingsRpc',
  rpcName: 'updateUserThemeSetting',
  auth: 'app',
  fingerprint: '3zO96LMTJyiOUe2e_r4XmZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};